import { Link } from 'react-router';
import { PageHeader } from '@/components/common/PageHeader';
import { PageMeta } from '@/components/common/PageMeta';
import { Button } from '@/components/ui/button';
import { Routes } from '@/constants/routes';
import { NotFoundPage } from '@/pages/NotFound/data';

export default function NotFound() {
  return (
    <>
      <PageMeta title={NotFoundPage.title} description={NotFoundPage.description} noIndex />
      <PageHeader title={NotFoundPage.title} description={NotFoundPage.description}>
        <Button asChild>
          <Link to={Routes.home}>{NotFoundPage.homeLinkLabel}</Link>
        </Button>
        <Button asChild variant="outline">
          <Link to={Routes.contact}>{NotFoundPage.contactLinkLabel}</Link>
        </Button>
      </PageHeader>
    </>
  );
}